import { render, staticRenderFns } from "./VNM.vue?vue&type=template&id=a41a3606&scoped=true&"
import script from "./VNM.vue?vue&type=script&lang=js&"
export * from "./VNM.vue?vue&type=script&lang=js&"
import style0 from "./VNM.vue?vue&type=style&index=0&id=a41a3606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41a3606",
  null
  
)

export default component.exports